import SignUp from './components';

export default SignUp;
